export const CRUD_ACTION_CREATE = 'CREATE'
export const CRUD_ACTION_UPDATE = 'UPDATE'
export const CRUD_ACTION_DELETE = 'DELETE'
